import * as actions from './actions'
import { AdvancedAlertModalState } from './model'
import { AdvancedAlertModalActions } from './actions'

const initialState: AdvancedAlertModalState = {
  isAdvancedAlertModalOpened: false
}

const reducer = (state: AdvancedAlertModalState = initialState, action: AdvancedAlertModalActions): AdvancedAlertModalState => {
  switch (action.type) {
    case actions.HandleOpenModal:
      return {
        ...state,
        isAdvancedAlertModalOpened: true
      }
    case actions.HandleCloseModal:
      return {
        ...state,
        isAdvancedAlertModalOpened: false
      }
    default:
      return state
  }
}

export default reducer
